export type MetaTagInput = {
  title: string;
  description: string;
  canonicalUrl?: string;
  imageUrl?: string;
  siteName?: string;
  url?: string;
};

function escapeHtml(value: string) {
  return value
    .replace(/&/g, "&amp;")
    .replace(/"/g, "&quot;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

function tag(name: string, content: string, property = false) {
  const attr = property ? "property" : "name";
  return `<meta ${attr}="${name}" content="${escapeHtml(content)}">`;
}

export function generateMetaTags(input: MetaTagInput) {
  const lines = [
    `<title>${escapeHtml(input.title)}</title>`,
    tag("description", input.description),
  ];

  if (input.canonicalUrl) {
    lines.push(`<link rel="canonical" href="${escapeHtml(input.canonicalUrl)}">`);
  }

  lines.push(tag("og:title", input.title, true));
  lines.push(tag("og:description", input.description, true));

  if (input.url || input.canonicalUrl) {
    lines.push(tag("og:url", input.url || input.canonicalUrl || "", true));
  }

  if (input.siteName) {
    lines.push(tag("og:site_name", input.siteName, true));
  }

  if (input.imageUrl) {
    lines.push(tag("og:image", input.imageUrl, true));
  }

  lines.push(tag("twitter:card", input.imageUrl ? "summary_large_image" : "summary"));

  return lines.join("\n");
}
